import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

const AVATARS = [
  {
    key: '🦁', name: 'Sư tử',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBNDmAWATTpMW3CkiVJ8xwWWUR-2wkioJ94pux2aZopt_pBKSIqGu5H3jLOytBhMVfSNeXNDiZRYPoGRSBD9c8QEG-DBIubZiWTHLPicdzKQ9N-1Zk81v5Y3iOR2oGiSF7NIN1qMqdD26rLTr5QxXljoqw9-yrMSCZRLKWoj-mTuu8t1aImuroEIr3TuqWmnP3xbILJLHSVqiYn73BfdZbSwoZ8MwV-XIuR22HTJkEGmfGH-s80fJFvzu38F1l83A3Yo6wGvC9aig',
  },
  {
    key: '🐼', name: 'Gấu trúc',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuC45mC7D570qqivjjPg9ANnj6If71-cf-3ZnYc5oNtMnM8gmkxxTEvlp64Jtl_v-8qw5FkwqaSLjLDzz3D2nWZF-lIC_DD_4yvQBRtMoQ7-MG2f3ixRxFAvR18BoMsnscvszARFkuDyb4qzDwfSJjvlvd5bycXe-6nPjtV6mJwsVnYCF-AzHEEYCoO-rGQXe4GU756MfS9l00fCUcOdKX6Ml0QmUmpQVQYBOe4v0c00BxvE2XY9Xy4Dwy0aLhiLXkgcVYz40TGZbw',
  },
  {
    key: '🦊', name: 'Cáo',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAXE_fnjHhNZSBAtrtSwDmWcab6X8d5KVdhXqbY2aPI9lljxunfXtJgdjTrN6wwzAt1gNll81f2WZwiekqVhIr00kJ5VeG1qWhKKexByRXJJSW1nwjPErBepfp3sRtOZD1de7N-T566a5dhz2ZT8RMgXK2GDR7pGHChFCd9JmBYLE2loD6PIKnttjwI0JpOajzawHnwzbO2Ya8ktPKTDc8yqx0JHJnq5sHZGmb3gbbBG8syWpZndXB0VNaatT6wipuHnrkQP5FTUw',
  },
  {
    key: '🐨', name: 'Koala',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBhJ-r1q9F7TXSVns0IELX0NavehqiTVhG1Izlo7GBUd_v6arWVtEWW6xSC6dg5PuGjf7FiUk118YVob4fAyuMdMylnu-K3DV5Ksb4oypdLGBEo1ATuBTVTX8gbg-cH_SR7XEtexx_FOOQSahVEHzuFa8vGrK4sCncz_jIt7_fSkZfkRiCEpo102c6uFxpdYxfe_ojKQ1w2Zj2gPOSJorij0IU1dWQOmgLreI5fzsCpRgxuFSmiSLSK52dTm8AXychp2lxi-vMukg',
  },
  {
    key: '🦄', name: 'Kỳ lân',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDBAzq0WNSzT2JcK98iuDLFkyLuzFkxzeixscO9Ad1OJXtgjlF-OINvbtrlM3KDQp5hJZxOr9H3e9r_ARGb6Zv6gCLUhZi8XD6pYk1hLbPUrTzoxAtjjwFWtpkq4kBNCws0gesrC46thfvHKnHFbyirRnbhoPg6dA8ePXzWyvwKQldotUQuUX9pV5X93tJOi-nVBTpbL9ITQmP0BddTkBn3vLnEeAswiQLEiPDTRx0Tm1vi1mU_mBBcgR4-jAio-E0cWzLH8ZFMSA',
  },
  {
    key: '🐯', name: 'Hổ',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBkErZ30H_6YZBKes44AtC1h2nC5Y_EZGY-JPSED_ipK-yyHRnzjmulVVCjct_28Pz3P6QphR-AVgGuJ6-DHQoaJDlUiIwetmdupemPwenpSO46aZTScND08BBWdwgVZkUn2gSOVx-82cKD2xBs0kSu08o-ju5cRWUZPwZ_OfT3lJLmsY9ipy8kJYP4CLbftOujFkxoaX-uOQnO2m4TW01Tmo5FHz7YnK6H4wYKKbcadCNnYqtgj2UFV4FBRmAD_7sU0UqjN9JW6A',
  },
];

const LEVEL_META = {
  Starters: { emoji: '🌱', cefr: 'A1', desc: 'Cấp độ A1 - Dành cho người mới bắt đầu', bgColor: 'bg-green-100' },
  Movers:   { emoji: '🚀', cefr: 'A1+', desc: 'Cấp độ A1+ - Đã có nền tảng cơ bản', bgColor: 'bg-blue-100' },
  Flyers:   { emoji: '✈️', cefr: 'A2', desc: 'Cấp độ A2 - Sẵn sàng bay cao!', bgColor: 'bg-purple-100' },
};

const Onboarding = () => {
  const [levels, setLevels] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const userName = localStorage.getItem('userFullName') || 'Bạn';

  useEffect(() => {
    const fetchLevels = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/levels/?skip=0&limit=10`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            accept: 'application/json',
          },
        });
        if (response.ok) {
          const data = await response.json();
          setLevels(data.data || data);
        }
      } catch (err) {
        console.error('Failed to fetch levels:', err);
      }
    };
    fetchLevels();
  }, []);

  const handleSubmit = async () => {
    if (!selectedLevel || !selectedAvatar) return;
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/client/onboarding/profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          accept: 'application/json',
        },
        body: JSON.stringify({ level_id: selectedLevel, avatar: selectedAvatar }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Lỗi khi lưu thông tin');
      }

      localStorage.setItem('userAvatar', selectedAvatar);
      navigate('/placement-test-intro');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ob-sky-voyager font-body text-hp-on-surface min-h-screen flex flex-col items-center justify-center p-4 relative overflow-x-hidden">

      {/* Background patterns (matching Stitch) */}
      <div className="fixed inset-0 ob-cloud-pattern pointer-events-none"></div>
      <div className="fixed inset-0 ob-star-pattern opacity-30 pointer-events-none"></div>

      {/* Main Onboarding Card */}
      <main className="w-full max-w-[800px] mt-8 mb-12 z-10">
        <div className="bg-white rounded-xl shadow-[0px_12px_32px_rgba(94,46,26,0.08)] p-8 md:p-12">

          {/* Step indicator */}
          <div className="flex flex-col gap-4 mb-8">
            <div className="flex justify-between items-center font-label text-sm font-semibold text-hupath-scout">
              <span>Bước 1/2</span>
              <span>50%</span>
            </div>
            <div className="w-full h-3 bg-hp-surface-container rounded-full overflow-hidden">
              <div className="w-1/2 h-full bg-gradient-to-r from-hupath-scout to-hupath-leaf rounded-full"></div>
            </div>
          </div>

          {/* Welcome Header */}
          <header className="mb-10">
            <h1 className="font-headline text-3xl md:text-4xl font-extrabold text-hp-on-surface leading-tight mb-2">
              Chào mừng, {userName}! 👋
            </h1>
            <p className="font-body text-lg italic text-hp-on-surface-variant">
              Hãy cho chúng mình biết thêm về con nhé
            </p>
          </header>

          {/* Level Selection */}
          <section className="mb-12">
            <h2 className="font-headline text-xl font-bold mb-6 flex items-center gap-2">
              <span className="material-symbols-outlined text-hupath-scout">school</span>
              Con đang chuẩn bị thi gì?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {levels.map((level) => {
                const meta = LEVEL_META[level.name] || { emoji: '📚', cefr: '', desc: '', bgColor: 'bg-gray-100' };
                const isSelected = selectedLevel === level.id;
                return (
                  <button
                    key={level.id}
                    onClick={() => setSelectedLevel(level.id)}
                    className={`flex flex-col p-6 rounded-lg transition-all duration-300 group text-left
                      ${isSelected
                        ? 'bg-hupath-scout/10 border-2 border-hupath-scout ring-4 ring-hupath-scout/5'
                        : 'bg-gray-50 hover:bg-gray-100 border-none'
                      }`}
                  >
                    <div className={`w-14 h-14 rounded-full ${meta.bgColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                      <span className="text-3xl" role="img" aria-label={level.name}>{meta.emoji}</span>
                    </div>
                    <h3 className={`font-headline font-bold mb-2 ${isSelected ? 'text-hupath-scout' : 'text-hp-on-surface'}`}>
                      {level.name}
                    </h3>
                    <p className="font-body text-sm text-hp-on-surface-variant">{meta.desc}</p>
                  </button>
                );
              })}
            </div>
          </section>

          {/* Avatar Selection – using 3D avatar images from Stitch */}
          <section className="mb-12">
            <h2 className="font-headline text-xl font-bold mb-6 flex items-center gap-2">
              <span className="material-symbols-outlined text-hupath-scout">face</span>
              Chọn avatar của con:
            </h2>
            <div className="flex flex-wrap justify-between gap-4">
              {AVATARS.map(({ key, name, img }) => {
                const isSelected = selectedAvatar === key;
                return (
                  <button
                    key={key}
                    onClick={() => setSelectedAvatar(key)}
                    className="flex flex-col items-center gap-2 group cursor-pointer"
                  >
                    <div className={`w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden flex items-center justify-center transition-all
                      ${isSelected
                        ? 'border-4 border-hupath-scout ring-4 ring-hupath-scout/10 scale-110'
                        : 'bg-hp-surface-container-high border-4 border-transparent hover:border-hupath-leaf/50'
                      }`}>
                      <img
                        src={img}
                        alt={name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <span className={`font-label text-xs font-semibold ${isSelected ? 'text-hupath-scout font-bold' : 'text-hp-on-surface-variant'}`}>
                      {name}
                    </span>
                  </button>
                );
              })}
            </div>
          </section>

          {/* Error */}
          {error && (
            <div className="flex items-center gap-2 bg-red-50 border border-red-300 rounded-xl px-4 py-3 text-red-600 text-sm font-medium mb-6">
              <span className="material-symbols-outlined text-lg">error</span>{error}
            </div>
          )}

          {/* CTA */}
          <footer className="flex flex-col items-center gap-4">
            <button
              onClick={handleSubmit}
              disabled={!selectedLevel || !selectedAvatar || isLoading}
              className="w-full hp-button-gradient text-white font-headline font-bold text-xl py-5 rounded-lg shadow-xl shadow-hupath-scout/20 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
            >
              {isLoading ? (
                <><span className="material-symbols-outlined lf-spin">progress_activity</span> Đang lưu...</>
              ) : 'Tiếp tục →'}
            </button>
            <div className="flex items-center gap-2 text-hp-on-surface-variant">
              <span className="material-symbols-outlined text-sm">info</span>
              <p className="font-label text-sm italic">
                Bước tiếp theo: Bài đánh giá đầu vào (15 câu, ~10 phút)
              </p>
            </div>
          </footer>
        </div>
      </main>

      {/* Bottom cloud ornament (matching Stitch) */}
      <div className="fixed bottom-[-100px] left-1/2 -translate-x-1/2 w-[120%] h-[300px] bg-white rounded-[50%] blur-3xl opacity-60 z-0"></div>
    </div>
  );
};

export default Onboarding;
